import { c as _c } from "react/compiler-runtime";
import type { VaultValue } from '@onefootprint/core';
import { useTranslation } from 'react-i18next';
const useGetCardIssuer = () => {
  const $ = _c(32);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldset.cards.cardBrands"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp9);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp10);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t1 || $[22] !== t10 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    const translations = {
      mastercard: t1,
      master_card: t2,
      visa: t3,
      amex: t4,
      american_express: t5,
      discover: t6,
      diners_club: t7,
      jcb: t8,
      union_pay: t9,
      unknown: t10
    };
    t11 = cardIssuer => typeof cardIssuer === "string" && translations[cardIssuer] || String(cardIssuer);
    $[21] = t1;
    $[22] = t10;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default useGetCardIssuer;
function _temp($) {
  return $.master_card;
}
function _temp2($_0) {
  return $_0.master_card;
}
function _temp3($_1) {
  return $_1.visa;
}
function _temp4($_2) {
  return $_2.amex;
}
function _temp5($_3) {
  return $_3.amex;
}
function _temp6($_4) {
  return $_4.discover;
}
function _temp7($_5) {
  return $_5.diners_club;
}
function _temp8($_6) {
  return $_6.jcb;
}
function _temp9($_7) {
  return $_7.union_pay;
}
function _temp10($_8) {
  return $_8.unknown;
}